import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getNotifications() {
    yield takeEvery(actions.FETCH_NOTIFICATIONS_REQUESTED, function* (action) {
        try {
          const notifications = yield call(actions.getNotifications, action.payload);
          yield put({ type: actions.FETCH_NOTIFICATIONS_SUCCEEDED, notifications });
        } catch (error) {
          yield put({ type: actions.FETCH_NOTIFICATIONS_FAILED, error: error.message });
        }
    });
}

export function* getNotificationsHistory() {
  yield takeEvery(actions.FETCH_NOTIFICATIONS_HISTORY_REQUESTED, function* (action) {
      try {
        const notifications = yield call(actions.getNotificationsHistory, action.payload);
        yield put({ type: actions.FETCH_NOTIFICATIONS_HISTORY_SUCCEEDED, notifications });
      } catch (error) {
        yield put({ type: actions.FETCH_NOTIFICATIONS_HISTORY_FAILED, error: error.message });
      }
  });
}

export function* pushNotifications() {
  yield takeEvery(actions.PUSH_NOTIFICATIONS_REQUESTED, function* (action) {
      try {
        const notifications = yield call(actions.createNotifications, action.payload);
        yield put({ type: actions.PUSH_NOTIFICATIONS_SUCCEEDED, notifications });
      } catch (error) {
        yield put({ type: actions.PUSH_NOTIFICATIONS_FAILED, error: error?.response?.data });
      }
  });
}


export function* subscribeNotification() {
    yield takeEvery(actions.SUBSCRIBE_NOTIFICATION_REQUESTED, function* (action) {
        try {
            const subscription = yield call(actions.subscribeNotification, action.payload);
            localStorage.removeItem('fcm_token');
            yield put({ type: actions.SUBSCRIBE_NOTIFICATION_SUCCEEDED, fcmToken: action.payload?.fcm_token, subscription });
        } catch (error) {
            yield put({ type: actions.SUBSCRIBE_NOTIFICATION_FAILED, error: error?.response?.data });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(getNotifications),
        fork(pushNotifications),
        fork(subscribeNotification),
        fork(getNotificationsHistory),
    ]);
}
